import { DataFetchingClient } from 'data-fetching-client';
let dataFetchingClient;
const getDataFetchingClient = options => {
  if (!dataFetchingClient) {
    dataFetchingClient = new DataFetchingClient(options);
  }
  return dataFetchingClient;
};
export { getDataFetchingClient };